// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%236d7085%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Ccircle cx=%2211%22 cy=%2211%22 r=%228%22/%3E%3Cline x1=%2221%22 y1=%2221%22 x2=%2216.65%22 y2=%2216.65%22/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --atlas-map-left-rail-offset: 416px;
  --atlas-map-left-rail-width: 400px;
  --atlas-map-search-top: 80px;
  --atlas-map-left-rail-top: 144px;
}

body {
  margin: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Simulation results map: marker detail popups (react-leaflet Popup) */
/* Ensure popup pane renders above the results sidebar (z-index 10) on smaller screens.
   Leaflet's popup pane lives inside the map container; we must lift it above siblings. */
.atlas-simulation-results-map .leaflet-popup-pane {
  z-index: 15;
}
.leaflet-container .sim-map-point-popup .leaflet-popup-content-wrapper {
  padding: 0;
  border-radius: 12px;
  overflow: hidden;
  background: transparent;
  box-shadow: none;
  border: none;
}
.leaflet-container .sim-map-point-popup .leaflet-popup-content {
  margin: 0;
  line-height: 1.3;
}
.leaflet-container .sim-map-point-popup .leaflet-popup-tip-container {
  margin-top: -1px;
}
.leaflet-container .sim-map-point-popup .leaflet-popup-tip {
  background: #ffffff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.10);
}

/* Force side placement classes to avoid route overlap with default top anchor. */
.leaflet-container .leaflet-popup.sim-map-point-popup--left {
  transform: translate3d(-170px, -8px, 0);
}
.leaflet-container .leaflet-popup.sim-map-point-popup--right {
  transform: translate3d(170px, -8px, 0);
}
.leaflet-container .leaflet-popup.sim-map-point-popup--bottom {
  transform: translate3d(0, 120px, 0);
}

/* Main map (/): zoom bottom-right, above basemap switcher — hides any duplicate default top-left zoom */
.atlas-main-map.leaflet-container .leaflet-top.leaflet-left .leaflet-control-zoom,
.atlas-simulation-results-map.leaflet-container .leaflet-top.leaflet-left .leaflet-control-zoom {
  display: none !important;
}

/* Zoom controls: align with BasemapSwitcher pill look (theme surface.elevated + borderSubtle, radius 24) */
.atlas-main-map.leaflet-container .leaflet-bottom.leaflet-right .leaflet-control-zoom.leaflet-bar,
.atlas-simulation-results-map.leaflet-container .leaflet-bottom.leaflet-right .leaflet-control-zoom.leaflet-bar {
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid rgba(58, 58, 72, 0.12);
  box-shadow:
    0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
}

/* Compact zoom cells (narrower than basemap toggles; still easy to tap) */
.atlas-main-map.leaflet-container .leaflet-bottom.leaflet-right .leaflet-control-zoom a,
.atlas-simulation-results-map.leaflet-container .leaflet-bottom.leaflet-right .leaflet-control-zoom a {
  border-radius: 0 !important;
  border-bottom-color: rgba(58, 58, 72, 0.12);
  box-sizing: border-box !important;
  width: 32px !important;
  min-width: 32px !important;
  height: 30px !important;
  line-height: 30px !important;
  font-size: 16px !important;
}

.atlas-main-map.leaflet-container.leaflet-touch .leaflet-bottom.leaflet-right .leaflet-control-zoom a,
.atlas-simulation-results-map.leaflet-container.leaflet-touch .leaflet-bottom.leaflet-right .leaflet-control-zoom a {
  width: 32px !important;
  min-width: 32px !important;
  height: 30px !important;
  line-height: 30px !important;
  font-size: 16px !important;
}

/*
 * Bottom-right stack: same horizontal inset as BasemapSwitcher (MAP_UI_CORNER_INSET_PX + --map-ui-inset).
 * Padding on the Leaflet corner aligns floated controls to the inner edge; zoom margin-right stays 0.
 */
.atlas-main-map.leaflet-container .leaflet-bottom.leaflet-right,
.atlas-simulation-results-map.leaflet-container .leaflet-bottom.leaflet-right {
  padding-right: 32px;
  padding-right: var(--map-ui-inset, 32px);
  box-sizing: border-box;
}

.atlas-main-map.leaflet-container .leaflet-bottom.leaflet-right .leaflet-control-zoom {
  margin-bottom: 80px;
  margin-right: 0 !important;
}

.atlas-main-map.leaflet-container .leaflet-bottom.leaflet-right .leaflet-control-attribution {
  margin-right: calc(64px - 32px);
  margin-right: calc(64px - var(--map-ui-inset, 32px));
}

/* Simulation results full-page map: zoom sits above bottom analytics deck (offset via --sim-map-zoom-bottom-offset on parent) */
.atlas-simulation-results-map.leaflet-container .leaflet-bottom.leaflet-right .leaflet-control-zoom {
  margin-bottom: calc(260px + 12px);
  margin-bottom: calc(var(--sim-map-zoom-bottom-offset, 260px) + 12px);
  margin-right: 0 !important;
}

/* Main map search control: align with Atlas surface/border language */
.atlas-main-map.leaflet-container .geosearch.leaflet-bar.leaflet-control.leaflet-control-geosearch.leaflet-geosearch-bar {
  display: none !important;
}

.atlas-main-map.leaflet-container .leaflet-control-geosearch.leaflet-geosearch-bar {
  position: fixed !important;
  top: 80px !important;
  top: var(--atlas-map-search-top) !important;
  left: 416px !important;
  left: var(--atlas-map-left-rail-offset) !important;
  right: auto !important;
  z-index: 1101 !important;
  width: min(400px, calc(100vw - (416px * 2)));
  width: min(var(--atlas-map-left-rail-width), calc(100vw - (var(--atlas-map-left-rail-offset) * 2)));
  margin: 0 !important;
  transform: none !important;
  display: block;
}

.atlas-main-map.leaflet-container .leaflet-geosearch-bar {
  width: min(400px, calc(100vw - (416px * 2)));
  width: min(var(--atlas-map-left-rail-width), calc(100vw - (var(--atlas-map-left-rail-offset) * 2)));
  margin: 0 !important;
  transform: none !important;
}

.atlas-main-map.leaflet-container .leaflet-control-geosearch form {
  display: block;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  min-height: 54px;
  border-radius: 24px;
  border: 1px solid rgba(58, 58, 72, 0.12);
  background-color: #ffffff;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.14);
  padding: 0 44px 0 46px;
  overflow: visible;
}

.atlas-main-map.leaflet-container .leaflet-control-geosearch form::before {
  content: '';
  position: absolute;
  left: 16px;
  top: 50%;
  width: 20px;
  height: 20px;
  transform: translateY(-50%);
  opacity: 0.72;
  pointer-events: none;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.atlas-main-map.leaflet-container .leaflet-control-geosearch form input {
  display: block;
  width: 100%;
  min-width: 0;
  height: 54px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
  font-size: 15px;
  font-weight: 500;
  color: #25253a;
  border-radius: 24px;
  text-indent: 0;
  letter-spacing: 0.1px;
  border: none !important;
  box-shadow: none !important;
  background: transparent;
  outline: none;
}

.atlas-main-map.leaflet-container .leaflet-control-geosearch form input::placeholder {
  color: #6d7085;
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  opacity: 1;
}

.atlas-main-map.leaflet-container .leaflet-control-geosearch form:focus-within {
  border-color: #f56f42;
  box-shadow: 0 0 0 3px rgba(245, 111, 66, 0.18);
}

.atlas-main-map.leaflet-container .leaflet-control-geosearch button.reset {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  border-radius: 16px;
  margin: 0;
  line-height: 1;
  font-size: 18px;
  color: #4a4f63;
  display: flex;
  align-items: center;
  justify-content: center;
}

.atlas-main-map.leaflet-container .leaflet-control-geosearch form:has(input:placeholder-shown) button.reset {
  display: none;
}

.atlas-main-map.leaflet-container .leaflet-control-geosearch form:has(input:not(:placeholder-shown)) button.reset {
  display: flex;
}

.atlas-main-map.leaflet-container .leaflet-control-geosearch .results {
  display: none;
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  width: 100%;
  z-index: 1102;
  border-radius: 0 0 16px 16px;
  border: 1px solid rgba(58, 58, 72, 0.12);
  background-color: rgba(248, 250, 252, 0.96);
  box-sizing: border-box;
  overflow: hidden;
  box-shadow:
    0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.atlas-main-map.leaflet-container .leaflet-control-geosearch .results.active {
  display: block;
  padding: 6px 0;
  border-top: 1px solid rgba(58, 58, 72, 0.12);
}

.atlas-main-map.leaflet-container .leaflet-control-geosearch .results > .active,
.atlas-main-map.leaflet-container .leaflet-control-geosearch .results > :hover {
  background-color: #fff4ee;
  border-color: #f8d1c1;
}

.atlas-main-map.leaflet-container .leaflet-control-geosearch .results > * {
  line-height: 30px;
  padding: 6px 12px;
  font-size: 14px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
  color: #2f3241;
}

.atlas-main-map.leaflet-container .leaflet-control-geosearch .results.active:after {
  display: none;
}

/*
 * Fixed-route loading lines: a dotted line that "throbs" (marching dashes travelling
 * start -> finish) while a route's real geometry is still being calculated. The dotted
 * line stays on the map until the real routed line returns and replaces it. Shared by:
 *  - the stop-by-stop capture preview (.fixed-route-capture-preview, in map.tsx)
 *  - the move-a-point drag preview and the circulator return-leg loading line
 *    (.fr-loading-dash, in map_line_functions.tsx)
 * The dotted PATTERN is set inline on each Polyline (stroke-dasharray '2 10', period 12),
 * so the line is dotted even if this stylesheet hasn't loaded yet; this rule only adds the
 * "marching" animation. The keyframe shifts stroke-dashoffset by exactly one dash period so
 * the loop is seamless. Animation is auto-neutralised under automation mode (see App.css).
 */
.leaflet-container .fr-loading-dash,
.leaflet-container .fixed-route-capture-preview {
  animation: frLoadingDash 0.6s linear infinite;
}

@keyframes frLoadingDash {
  to {
    stroke-dashoffset: -12;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,wGAAwG;EACxG,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,uEAAuE;AACvE;yFACyF;AACzF;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,iFAAiF;AACjF;EACE,uCAAuC;AACzC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,mCAAmC;AACrC;;AAEA,wGAAwG;AACxG;;EAEE,wBAAwB;AAC1B;;AAEA,2GAA2G;AAC3G;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC;;;uCAGqC;EACrC,yBAAyB;AAC3B;;AAEA,0EAA0E;AAC1E;;EAEE,2BAA2B;EAC3B,2CAA2C;EAC3C,iCAAiC;EACjC,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;;;EAGE;AACF;;EAEE,mBAAwC;EAAxC,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,+BAAoD;EAApD,oDAAoD;AACtD;;AAEA,gIAAgI;AAChI;EACE,iCAAoE;EAApE,oEAAoE;EACpE,0BAA0B;AAC5B;;AAEA,sEAAsE;AACtE;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,oBAA2C;EAA3C,2CAA2C;EAC3C,sBAAkD;EAAlD,kDAAkD;EAClD,sBAAsB;EACtB,wBAAwB;EACxB,4CAAmG;EAAnG,mGAAmG;EACnG,oBAAoB;EACpB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,4CAAmG;EAAnG,mGAAmG;EACnG,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;EACzB,6CAA6C;EAC7C,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,oBAAoB;EACpB,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,yDAAiW;AACnW;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,wGAAwG;EACxG,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,wCAAwC;EACxC,2CAA2C;EAC3C,sBAAsB;EACtB,gBAAgB;EAChB;;;uCAGqC;AACvC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,4CAA4C;AAC9C;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,wGAAwG;EACxG,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;;;;;EAWE;AACF;;EAEE,6CAA6C;AAC/C;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');\n\n:root {\n  --atlas-map-left-rail-offset: 416px;\n  --atlas-map-left-rail-width: 400px;\n  --atlas-map-search-top: 80px;\n  --atlas-map-left-rail-top: 144px;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Simulation results map: marker detail popups (react-leaflet Popup) */\n/* Ensure popup pane renders above the results sidebar (z-index 10) on smaller screens.\n   Leaflet's popup pane lives inside the map container; we must lift it above siblings. */\n.atlas-simulation-results-map .leaflet-popup-pane {\n  z-index: 15;\n}\n.leaflet-container .sim-map-point-popup .leaflet-popup-content-wrapper {\n  padding: 0;\n  border-radius: 12px;\n  overflow: hidden;\n  background: transparent;\n  box-shadow: none;\n  border: none;\n}\n.leaflet-container .sim-map-point-popup .leaflet-popup-content {\n  margin: 0;\n  line-height: 1.3;\n}\n.leaflet-container .sim-map-point-popup .leaflet-popup-tip-container {\n  margin-top: -1px;\n}\n.leaflet-container .sim-map-point-popup .leaflet-popup-tip {\n  background: #ffffff;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.10);\n}\n\n/* Force side placement classes to avoid route overlap with default top anchor. */\n.leaflet-container .leaflet-popup.sim-map-point-popup--left {\n  transform: translate3d(-170px, -8px, 0);\n}\n.leaflet-container .leaflet-popup.sim-map-point-popup--right {\n  transform: translate3d(170px, -8px, 0);\n}\n.leaflet-container .leaflet-popup.sim-map-point-popup--bottom {\n  transform: translate3d(0, 120px, 0);\n}\n\n/* Main map (/): zoom bottom-right, above basemap switcher — hides any duplicate default top-left zoom */\n.atlas-main-map.leaflet-container .leaflet-top.leaflet-left .leaflet-control-zoom,\n.atlas-simulation-results-map.leaflet-container .leaflet-top.leaflet-left .leaflet-control-zoom {\n  display: none !important;\n}\n\n/* Zoom controls: align with BasemapSwitcher pill look (theme surface.elevated + borderSubtle, radius 24) */\n.atlas-main-map.leaflet-container .leaflet-bottom.leaflet-right .leaflet-control-zoom.leaflet-bar,\n.atlas-simulation-results-map.leaflet-container .leaflet-bottom.leaflet-right .leaflet-control-zoom.leaflet-bar {\n  border-radius: 24px;\n  overflow: hidden;\n  border: 1px solid rgba(58, 58, 72, 0.12);\n  box-shadow:\n    0px 3px 1px -2px rgba(0, 0, 0, 0.2),\n    0px 2px 2px 0px rgba(0, 0, 0, 0.14),\n    0px 1px 5px 0px rgba(0, 0, 0, 0.12);\n  background-color: #ffffff;\n}\n\n/* Compact zoom cells (narrower than basemap toggles; still easy to tap) */\n.atlas-main-map.leaflet-container .leaflet-bottom.leaflet-right .leaflet-control-zoom a,\n.atlas-simulation-results-map.leaflet-container .leaflet-bottom.leaflet-right .leaflet-control-zoom a {\n  border-radius: 0 !important;\n  border-bottom-color: rgba(58, 58, 72, 0.12);\n  box-sizing: border-box !important;\n  width: 32px !important;\n  min-width: 32px !important;\n  height: 30px !important;\n  line-height: 30px !important;\n  font-size: 16px !important;\n}\n\n.atlas-main-map.leaflet-container.leaflet-touch .leaflet-bottom.leaflet-right .leaflet-control-zoom a,\n.atlas-simulation-results-map.leaflet-container.leaflet-touch .leaflet-bottom.leaflet-right .leaflet-control-zoom a {\n  width: 32px !important;\n  min-width: 32px !important;\n  height: 30px !important;\n  line-height: 30px !important;\n  font-size: 16px !important;\n}\n\n/*\n * Bottom-right stack: same horizontal inset as BasemapSwitcher (MAP_UI_CORNER_INSET_PX + --map-ui-inset).\n * Padding on the Leaflet corner aligns floated controls to the inner edge; zoom margin-right stays 0.\n */\n.atlas-main-map.leaflet-container .leaflet-bottom.leaflet-right,\n.atlas-simulation-results-map.leaflet-container .leaflet-bottom.leaflet-right {\n  padding-right: var(--map-ui-inset, 32px);\n  box-sizing: border-box;\n}\n\n.atlas-main-map.leaflet-container .leaflet-bottom.leaflet-right .leaflet-control-zoom {\n  margin-bottom: 80px;\n  margin-right: 0 !important;\n}\n\n.atlas-main-map.leaflet-container .leaflet-bottom.leaflet-right .leaflet-control-attribution {\n  margin-right: calc(64px - var(--map-ui-inset, 32px));\n}\n\n/* Simulation results full-page map: zoom sits above bottom analytics deck (offset via --sim-map-zoom-bottom-offset on parent) */\n.atlas-simulation-results-map.leaflet-container .leaflet-bottom.leaflet-right .leaflet-control-zoom {\n  margin-bottom: calc(var(--sim-map-zoom-bottom-offset, 260px) + 12px);\n  margin-right: 0 !important;\n}\n\n/* Main map search control: align with Atlas surface/border language */\n.atlas-main-map.leaflet-container .geosearch.leaflet-bar.leaflet-control.leaflet-control-geosearch.leaflet-geosearch-bar {\n  display: none !important;\n}\n\n.atlas-main-map.leaflet-container .leaflet-control-geosearch.leaflet-geosearch-bar {\n  position: fixed !important;\n  top: var(--atlas-map-search-top) !important;\n  left: var(--atlas-map-left-rail-offset) !important;\n  right: auto !important;\n  z-index: 1101 !important;\n  width: min(var(--atlas-map-left-rail-width), calc(100vw - (var(--atlas-map-left-rail-offset) * 2)));\n  margin: 0 !important;\n  transform: none !important;\n  display: block;\n}\n\n.atlas-main-map.leaflet-container .leaflet-geosearch-bar {\n  width: min(var(--atlas-map-left-rail-width), calc(100vw - (var(--atlas-map-left-rail-offset) * 2)));\n  margin: 0 !important;\n  transform: none !important;\n}\n\n.atlas-main-map.leaflet-container .leaflet-control-geosearch form {\n  display: block;\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n  min-height: 54px;\n  border-radius: 24px;\n  border: 1px solid rgba(58, 58, 72, 0.12);\n  background-color: #ffffff;\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.14);\n  padding: 0 44px 0 46px;\n  overflow: visible;\n}\n\n.atlas-main-map.leaflet-container .leaflet-control-geosearch form::before {\n  content: '';\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  width: 20px;\n  height: 20px;\n  transform: translateY(-50%);\n  opacity: 0.72;\n  pointer-events: none;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 20px 20px;\n  background-image: url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%236d7085%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Ccircle cx=%2211%22 cy=%2211%22 r=%228%22/%3E%3Cline x1=%2221%22 y1=%2221%22 x2=%2216.65%22 y2=%2216.65%22/%3E%3C/svg%3E');\n}\n\n.atlas-main-map.leaflet-container .leaflet-control-geosearch form input {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  height: 54px;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  color: #25253a;\n  border-radius: 24px;\n  text-indent: 0;\n  letter-spacing: 0.1px;\n  border: none !important;\n  box-shadow: none !important;\n  background: transparent;\n  outline: none;\n}\n\n.atlas-main-map.leaflet-container .leaflet-control-geosearch form input::placeholder {\n  color: #6d7085;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 500;\n  opacity: 1;\n}\n\n.atlas-main-map.leaflet-container .leaflet-control-geosearch form:focus-within {\n  border-color: #f56f42;\n  box-shadow: 0 0 0 3px rgba(245, 111, 66, 0.18);\n}\n\n.atlas-main-map.leaflet-container .leaflet-control-geosearch button.reset {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  flex: 0 0 28px;\n  width: 28px;\n  height: 28px;\n  border-radius: 16px;\n  margin: 0;\n  line-height: 1;\n  font-size: 18px;\n  color: #4a4f63;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.atlas-main-map.leaflet-container .leaflet-control-geosearch form:has(input:placeholder-shown) button.reset {\n  display: none;\n}\n\n.atlas-main-map.leaflet-container .leaflet-control-geosearch form:has(input:not(:placeholder-shown)) button.reset {\n  display: flex;\n}\n\n.atlas-main-map.leaflet-container .leaflet-control-geosearch .results {\n  display: none;\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  width: 100%;\n  z-index: 1102;\n  border-radius: 0 0 16px 16px;\n  border: 1px solid rgba(58, 58, 72, 0.12);\n  background-color: rgba(248, 250, 252, 0.96);\n  box-sizing: border-box;\n  overflow: hidden;\n  box-shadow:\n    0px 3px 1px -2px rgba(0, 0, 0, 0.2),\n    0px 2px 2px 0px rgba(0, 0, 0, 0.14),\n    0px 1px 5px 0px rgba(0, 0, 0, 0.12);\n}\n\n.atlas-main-map.leaflet-container .leaflet-control-geosearch .results.active {\n  display: block;\n  padding: 6px 0;\n  border-top: 1px solid rgba(58, 58, 72, 0.12);\n}\n\n.atlas-main-map.leaflet-container .leaflet-control-geosearch .results > .active,\n.atlas-main-map.leaflet-container .leaflet-control-geosearch .results > :hover {\n  background-color: #fff4ee;\n  border-color: #f8d1c1;\n}\n\n.atlas-main-map.leaflet-container .leaflet-control-geosearch .results > * {\n  line-height: 30px;\n  padding: 6px 12px;\n  font-size: 14px;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;\n  color: #2f3241;\n}\n\n.atlas-main-map.leaflet-container .leaflet-control-geosearch .results.active:after {\n  display: none;\n}\n\n/*\n * Fixed-route loading lines: a dotted line that \"throbs\" (marching dashes travelling\n * start -> finish) while a route's real geometry is still being calculated. The dotted\n * line stays on the map until the real routed line returns and replaces it. Shared by:\n *  - the stop-by-stop capture preview (.fixed-route-capture-preview, in map.tsx)\n *  - the move-a-point drag preview and the circulator return-leg loading line\n *    (.fr-loading-dash, in map_line_functions.tsx)\n * The dotted PATTERN is set inline on each Polyline (stroke-dasharray '2 10', period 12),\n * so the line is dotted even if this stylesheet hasn't loaded yet; this rule only adds the\n * \"marching\" animation. The keyframe shifts stroke-dashoffset by exactly one dash period so\n * the loop is seamless. Animation is auto-neutralised under automation mode (see App.css).\n */\n.leaflet-container .fr-loading-dash,\n.leaflet-container .fixed-route-capture-preview {\n  animation: frLoadingDash 0.6s linear infinite;\n}\n\n@keyframes frLoadingDash {\n  to {\n    stroke-dashoffset: -12;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
